export const contactsData = {
    email: 'langahoohlogmail.com',
    phone: '+26659181310',
    address: 'Ha Tsiu, Maseru, Lesotho - 100 ',
    github: 'https://github.com/Langahoohlo',
    facebook: 'https://www.facebook.com/langa.hoohlo.3/',
    linkedIn: 'https://www.linkedin.com/in/langa-hoohlo-404608229/',
    twitter: 'https://twitter.com/LangaHoohlo',
}